import { PRICING_MODELS } from '@/services/constants';
import { QUIZ_PRODUCT_TYPES } from './product';
const ProductService = {
    isValidProductType(productType) {
        return Object.values(QUIZ_PRODUCT_TYPES).includes(productType);
    },
    isValidPricingModel(pricingModel) {
        return Object.values(PRICING_MODELS).includes(pricingModel);
    },
    isWeeklyProduct(pricingModel) {
        return pricingModel === PRICING_MODELS.weekly;
    },
    isMonthlyProduct(pricingModel) {
        return pricingModel === PRICING_MODELS.monthly;
    },
};
export default ProductService;
